
(function(){var g=(window.MP_FREE_SHIPPING_CENTS||4000)/100,t='$'+(g%1?g.toFixed(2):g.toFixed(0));document.querySelectorAll('.mpx-ship-amt').forEach(function(e){e.textContent=t})})();
(function(){
'use strict';
var $=function(id){return document.getElementById(id)};
function fire(){document.dispatchEvent(new Event('mp:state'))}

/* =====================  FIT FINDER  ===================== */
var KG_PER_LB=0.45359237, EPS=0.02, NEAR=0.25, MAXKG=9;
var RANGES=[{size:'S',min:1.5,max:2.5},{size:'M',min:2.5,max:5},{size:'L',min:5,max:7.5}];
var unit='kg', who=1, picked=null;
var fitEls={};
function fmt(n){return (Math.round(n*10)/10).toString()}
function toKg(v){return unit==='lb'?v*KG_PER_LB:v}
function rangeLabel(r){return fmt(r.min)+'–'+fmt(r.max)+' kg · '+fmt(r.min/KG_PER_LB)+'–'+fmt(r.max/KG_PER_LB)+' lb'}
function recommend(kg){
  if(kg+EPS<1.5)return{status:'small'};
  if(kg-EPS>7.5)return{status:'large'};
  var size=(kg+EPS>=5)?'L':(kg+EPS>=2.5)?'M':'S';
  var idx=RANGES.findIndex(function(r){return r.size===size});
  var r=RANGES[idx], next=RANGES[idx+1]||null;
  var atBoundary=(Math.abs(kg-2.5)<=EPS||Math.abs(kg-5)<=EPS);
  var nearTop=next&&!atBoundary&&(r.max-kg)<=NEAR;
  if(nearTop)return{status:'ok',size:next.size,alt:size,why:'between',kg:kg,from:size};
  if(atBoundary)return{status:'ok',size:size,why:'boundary',kg:kg,lower:RANGES[idx-1].size};
  if(size==='L'&&(7.5-kg)<=NEAR)return{status:'ok',size:size,why:'topL',kg:kg};
  return{status:'ok',size:size,why:'range',kg:kg};
}
function buildScale(){
  var track=$('mpxTrack'),ticks=$('mpxTicks');
  if(!track||track.children.length)return;
  RANGES.forEach(function(r){
    var b=document.createElement('span');b.className='mpx-band';b.dataset.size=r.size;b.textContent=r.size;
    b.style.left=(r.min/MAXKG*100)+'%';b.style.width=((r.max-r.min)/MAXKG*100)+'%';track.appendChild(b);
  });
}
function updateTicks(){
  var t=$('mpxTicks');if(!t)return;t.textContent='';
  [0,1.5,2.5,5,7.5].forEach(function(k){
    var s=document.createElement('span');s.style.left=(k/MAXKG*100)+'%';
    s.textContent=unit==='kg'?fmt(k):fmt(k/KG_PER_LB);t.appendChild(s);
  });
  var u=document.createElement('span');u.style.left='94%';u.textContent=unit;t.appendChild(u);
}
function bundleOn(){return typeof state!=='undefined'&&!!state.bundle}
function renderFit(){
  var res=$('sizeResult'),pin=$('mpxPin'),raw=fitEls.weight.value.trim();
  document.querySelectorAll('#mpxTrack .mpx-band').forEach(function(b){b.classList.remove('on')});
  pin.classList.remove('show');picked=null;
  if(raw===''){res.innerHTML='<p class="mpx-hint">Type a weight to see your size.</p>';return}
  var v=Number(raw);
  if(!isFinite(v)||v<=0){res.innerHTML='<p class="mpx-warn">Please enter a weight greater than 0.</p>';return}
  var kg=toKg(v);
  pin.style.left=(Math.min(kg,MAXKG)/MAXKG*100)+'%';pin.classList.add('show');
  var rec=recommend(kg);
  if(rec.status==='small'){res.innerHTML='<p class="mpx-warn"><strong>A little smaller than our smallest size.</strong><br>Size S starts at 1.5 kg (3.3 lb), so the costume would likely be too big to sit securely.</p>';return}
  if(rec.status==='large'){res.innerHTML='<p class="mpx-warn"><strong>Bigger than our largest size.</strong><br>Size L fits up to 7.5 kg (16.5 lb), so this costume is likely too small for your pet. We’d rather you know before ordering.</p>';return}
  picked=rec.size;
  document.querySelectorAll('#mpxTrack .mpx-band').forEach(function(b){b.classList.toggle('on',b.dataset.size===rec.size)});
  var r=RANGES.find(function(x){return x.size===rec.size});
  var shown=fmt(unit==='kg'?kg:kg/KG_PER_LB)+' '+unit+' ('+fmt(unit==='kg'?kg/KG_PER_LB:kg)+' '+(unit==='kg'?'lb':'kg')+')';
  var why;
  if(rec.why==='between')why='At '+shown+' your pet is right at the top of size '+rec.from+'. Our guide says <strong>between sizes? Size up</strong>, so we suggest '+rec.size+'.';
  else if(rec.why==='boundary')why='At '+shown+' your pet sits exactly between '+rec.lower+' and '+rec.size+'. Our guide says <strong>between sizes? Size up</strong>, so we suggest '+rec.size+'.';
  else if(rec.why==='topL')why='At '+shown+' your pet is near the top of our largest size, so L should fit snugly. Check the size guide image for fit details.';
  else why='At '+shown+' your pet falls in the size '+rec.size+' range.';
  var forTxt=bundleOn()?(' for Pup '+who):'';
  var html='<div class="mpx-rec"><div class="mpx-badge">'+rec.size+'</div><div><strong>Size '+rec.size+' is the merry fit</strong><span>'+rangeLabel(r)+'</span></div></div><p class="mpx-why">'+why+'</p><button type="button" class="btn" data-apply="'+rec.size+'">Select size '+rec.size+forTxt+' →</button>';
  if(rec.alt)html+='<button type="button" class="mpx-alt" data-apply="'+rec.alt+'">Choose '+rec.alt+' instead</button>';
  res.innerHTML=html;
}
function applySize(size){
  var second=bundleOn()&&who===2;
  if(second){state.secondSize=size;setChoices('secondSizes','size',size)}else{selectSize(size)}
  closeSize();
  var target=$(second?'secondSizes':'sizes');
  if(target)setTimeout(function(){target.scrollIntoView({behavior:'smooth',block:'center'})},60);
  toast('Size '+size+' selected'+(second?' for Pup 2':''));
  fire();
}
function setUnit(u,convert){
  if(u===unit)return;
  var raw=fitEls.weight.value.trim(),v=Number(raw);
  if(convert&&raw!==''&&isFinite(v)&&v>0){fitEls.weight.value=fmt(u==='lb'?v/KG_PER_LB:v*KG_PER_LB)}
  unit=u;
  document.querySelectorAll('[data-unit]').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.unit===u))});
  updateTicks();renderFit();
}
function initFit(){
  fitEls.weight=$('weight');if(!fitEls.weight)return;
  buildScale();updateTicks();renderFit();
  fitEls.weight.addEventListener('input',renderFit);
  document.querySelectorAll('[data-unit]').forEach(function(b){b.addEventListener('click',function(){setUnit(b.dataset.unit,true)})});
  document.querySelectorAll('#mpxFitWho [data-who]').forEach(function(b){b.addEventListener('click',function(){
    who=Number(b.dataset.who);
    document.querySelectorAll('#mpxFitWho [data-who]').forEach(function(x){x.setAttribute('aria-pressed',String(x===b))});renderFit();
  })});
  $('sizeResult').addEventListener('click',function(e){var b=e.target.closest('[data-apply]');if(b)applySize(b.dataset.apply)});
}
window.mpxFitOpen=function(){
  var w=$('mpxFitWho');if(w)w.hidden=!bundleOn();
  if(!bundleOn()&&who!==1){who=1;document.querySelectorAll('#mpxFitWho [data-who]').forEach(function(x){x.setAttribute('aria-pressed',String(x.dataset.who==='1'))})}
  renderFit();
};

/* =====================  PUP PREVIEW  ===================== */
var cv=$('mpxCanvas');if(!cv)return;
var ctx=cv.getContext('2d');
var st={bg:null,x:600,y:660,scale:1,rot:0,flip:false,color:'Green',name:'',snow:true,has:false};
var costumes={},ready=0;

function starPts(cx,cy,ro,ri){var p=[];for(var i=0;i<10;i++){var a=-Math.PI/2+i*Math.PI/5,r=i%2?ri:ro;p.push((cx+r*Math.cos(a)).toFixed(1)+','+(cy+r*Math.sin(a)).toFixed(1))}return p.join(' ')}
function costumeSVG(color){
  var red=color==='Red';
  var c=red?{lt:'#f46a6e',md:'#d82f36',dk:'#85101a',t1:'#e8454b',t1d:'#9f1a22',str:'#f7ead7',pp:'#e5393f',ring:'#ff9ea1'}
           :{lt:'#46b866',md:'#218a43',dk:'#0c4a24',t1:'#34a457',t1d:'#115a2b',str:'#ffffff',pp:'#ffffff',ring:'#8fe0a6'};
  var outline='M200 34 C232 70 280 120 290 190 C292 216 304 236 322 252 C350 290 372 360 380 430 Q350 478 320 440 Q290 478 260 440 Q230 478 200 440 Q170 478 140 440 Q110 478 80 440 Q50 478 20 430 C28 360 50 290 78 252 C96 236 108 216 110 190 C120 120 168 70 200 34 Z';
  var hole='M134 172 a66 76 0 1 0 132 0 a66 76 0 1 0 -132 0 Z';
  var seg=57.6,x0=346,tier='M78 252 Q200 268 322 252 L346 326';
  var hem='';for(var i=0;i<5;i++){var a=x0-i*seg,b=a-seg;hem+=' Q'+((a+b)/2).toFixed(1)+' 364 '+b.toFixed(1)+' 328'}
  tier+=hem+' L58 326 Z';
  var folds='';for(var j=1;j<5;j++){var fx=x0-j*seg;folds+='<path d="M'+fx.toFixed(1)+' 330 q5 -26 -3 -52" stroke="'+c.t1d+'" stroke-width="3" fill="none" opacity=".3" stroke-linecap="round"/>'}
  var folds2='';[52,126,200,274,348].forEach(function(fx){folds2+='<path d="M'+fx+' 370 q6 22 0 46" stroke="'+c.dk+'" stroke-width="3" fill="none" opacity=".25" stroke-linecap="round"/>'});
  function pom(x,y,r,f){return '<circle cx="'+x+'" cy="'+y+'" r="'+r+'" fill="'+f+'" stroke="#000" stroke-opacity=".2" stroke-width="1.3"/><circle cx="'+(x-r*.32)+'" cy="'+(y-r*.34)+'" r="'+(r*.36)+'" fill="#fff" opacity=".5"/>'}
  var P='';
  [[150,88,11,'#e8383d'],[257,92,11,'#f4a6c4'],[284,150,12,'#f6c915'],[117,142,12,'#3b8fe0'],[293,214,11,'#7ed957'],[107,214,11,'#f28c28'],
   [84,298,12,'#3b8fe0'],[316,298,12,'#f28c28'],[52,404,12,'#f28c28'],[126,412,12,'#f4a6c4'],[200,404,12,'#f6c915'],[274,412,12,'#3b8fe0'],[348,404,12,'#7ed957']].forEach(function(p){P+=pom(p[0],p[1],p[2],p[3])});
  var tie='<path d="M200 262 C188 282 178 298 173 320 M200 262 C212 282 222 298 227 320" stroke="'+c.str+'" stroke-width="5" fill="none" stroke-linecap="round"/><circle cx="200" cy="262" r="7" fill="'+c.str+'" stroke="#000" stroke-opacity=".18"/>'+
    '<circle cx="171" cy="330" r="18" fill="'+c.pp+'" stroke="#000" stroke-opacity=".22" stroke-width="1.3"/><circle cx="164" cy="323" r="6" fill="#fff" opacity=".6"/>'+
    '<circle cx="229" cy="330" r="18" fill="'+c.pp+'" stroke="#000" stroke-opacity=".22" stroke-width="1.3"/><circle cx="222" cy="323" r="6" fill="#fff" opacity=".6"/>';
  var star='<polygon points="'+starPts(200,22,31,13)+'" fill="url(#gS)" stroke="#a97c0b" stroke-width="2" stroke-linejoin="round"/><polygon points="'+starPts(200,22,31,13)+'" fill="none" stroke="#fff6c9" stroke-width="1" opacity=".6" transform="translate(-1,-1)"/>';
  return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 500"><defs>'+
   '<linearGradient id="gF" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+c.lt+'"/><stop offset=".5" stop-color="'+c.md+'"/><stop offset="1" stop-color="'+c.dk+'"/></linearGradient>'+
   '<linearGradient id="gH" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#000" stop-opacity=".32"/><stop offset=".3" stop-color="#000" stop-opacity="0"/><stop offset=".7" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".32"/></linearGradient>'+
   '<linearGradient id="gT" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+c.lt+'"/><stop offset="1" stop-color="'+c.t1+'"/></linearGradient>'+
   '<linearGradient id="gS" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fff0a0"/><stop offset=".5" stop-color="#f2c230"/><stop offset="1" stop-color="#c98f0a"/></linearGradient></defs>'+
   '<g transform="translate(0,18)">'+
   '<path d="'+outline+' '+hole+'" fill="url(#gF)" fill-rule="evenodd"/>'+
   '<path d="'+outline+' '+hole+'" fill="url(#gH)" fill-rule="evenodd"/>'+
   folds2+
   '<path d="'+outline+'" fill="none" stroke="'+c.dk+'" stroke-width="2.4" stroke-linejoin="round" opacity=".7"/>'+
   '<ellipse cx="200" cy="172" rx="66" ry="76" fill="none" stroke="'+c.dk+'" stroke-width="8" opacity=".55"/>'+
   '<ellipse cx="200" cy="172" rx="71" ry="81" fill="none" stroke="'+c.ring+'" stroke-width="3.5" stroke-dasharray="1.5 5" stroke-linecap="round" opacity=".7"/>'+
   '<path d="'+tier+'" fill="#000" opacity=".22" transform="translate(0,7)"/>'+
   '<path d="'+tier+'" fill="url(#gT)" stroke="'+c.t1d+'" stroke-width="2" stroke-linejoin="round"/>'+folds+
   P+tie+star+'</g></svg>';
}
function loadCostumes(){
  ['Green','Red'].forEach(function(col){
    var im=new Image();
    im.onload=function(){ready++;render()};
    im.src='data:image/svg+xml;charset=utf-8,'+encodeURIComponent(costumeSVG(col));
    costumes[col]=im;
  });
}
function rng(seed){return function(){seed|=0;seed=seed+0x6D2B79F5|0;var t=Math.imul(seed^seed>>>15,1|seed);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296}}
function rrect(x,y,w,h,r){ctx.beginPath();ctx.moveTo(x+r,y);ctx.arcTo(x+w,y,x+w,y+h,r);ctx.arcTo(x+w,y+h,x,y+h,r);ctx.arcTo(x,y+h,x,y,r);ctx.arcTo(x,y,x+w,y,r);ctx.closePath()}
function drawCostume(alpha){
  var im=costumes[st.color];if(!im||!im.complete||!im.naturalWidth)return;
  var W=cv.width,dw=W*0.6*st.scale,dh=dw*1.25;
  ctx.save();ctx.globalAlpha=alpha==null?1:alpha;
  ctx.translate(st.x,st.y);ctx.rotate(st.rot*Math.PI/180);ctx.scale(st.flip?-1:1,1);
  ctx.shadowColor='rgba(15,40,25,.35)';ctx.shadowBlur=W*0.02;ctx.shadowOffsetY=W*0.008;
  ctx.drawImage(im,-dw/2,-dh/2,dw,dh);ctx.restore();
}
function render(){
  var W=cv.width,H=cv.height;ctx.clearRect(0,0,W,H);
  if(st.bg){ctx.drawImage(st.bg,0,0,W,H)}
  else{
    var g=ctx.createLinearGradient(0,0,0,H);g.addColorStop(0,'#fbf1dc');g.addColorStop(1,'#efdfc0');ctx.fillStyle=g;ctx.fillRect(0,0,W,H);
    var dw=W*0.6*st.scale,u=dw/400;
    ctx.save();ctx.translate(st.x,st.y);ctx.font=Math.round(u*78)+'px serif';ctx.textAlign='center';ctx.textBaseline='middle';ctx.globalAlpha=.5;ctx.fillText('🐾',0,-u*57);ctx.restore();
  }
  drawCostume(1);
  if(st.snow){
    var r=rng(7),n=Math.round(W*H/16000);
    for(var i=0;i<n;i++){var x=r()*W,y=r()*H,s=W*(0.0017+r()*0.0035);ctx.globalAlpha=.55+r()*.4;ctx.shadowColor='rgba(110,140,175,.55)';ctx.shadowBlur=W*0.004;ctx.fillStyle='#fff';ctx.beginPath();ctx.arc(x,y,s,0,6.2832);ctx.fill()}
    ctx.globalAlpha=1;ctx.shadowBlur=0;ctx.shadowColor='transparent';
  }
  if(st.has){
    if(st.name){
      var txt='Merry Christmas from '+st.name+'!',fs=W*0.05;
      ctx.font='italic 600 '+fs+'px Georgia,"Times New Roman",serif';
      while(ctx.measureText(txt).width>W*0.84&&fs>14){fs-=2;ctx.font='italic 600 '+fs+'px Georgia,"Times New Roman",serif'}
      var tw=ctx.measureText(txt).width,bw=tw+W*0.07,bh=fs*1.9,bx=(W-bw)/2,by=H-W*0.12-bh/2;
      ctx.save();ctx.shadowColor='rgba(0,0,0,.25)';ctx.shadowBlur=W*0.015;ctx.fillStyle='rgba(255,250,240,.94)';rrect(bx,by,bw,bh,bh/2);ctx.fill();ctx.restore();
      ctx.fillStyle='#123f2b';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText(txt,W/2,by+bh/2+fs*0.04);
    }
    ctx.save();ctx.font='700 '+(W*0.03)+'px Georgia,serif';ctx.textAlign='right';ctx.textBaseline='alphabetic';ctx.fillStyle='rgba(255,255,255,.95)';ctx.shadowColor='rgba(0,0,0,.5)';ctx.shadowBlur=W*0.008;ctx.fillText('MerryPaws ✦',W-W*0.035,H-W*0.03);ctx.restore();
  }
}
function tip(msg,err){var t=$('mpxTip');t.textContent=msg;t.classList.toggle('err',!!err)}
function resetPlace(){st.x=cv.width/2;st.y=cv.height*0.56;st.scale=1;st.rot=0;st.flip=false;syncUI()}
function syncUI(){
  $('mpxScale').value=Math.round(st.scale*100);$('mpxScaleOut').textContent=Math.round(st.scale*100)+'%';
  $('mpxRot').value=Math.round(st.rot);$('mpxRotOut').textContent=Math.round(st.rot)+'°';
}
function enable(on){
  $('mpxPanel').classList.toggle('off',!on);
  ['mpxScale','mpxRot','mpxFlip','mpxReset','mpxChange','mpxName','mpxSnow','mpxSave','mpxShare'].forEach(function(id){var e=$(id);if(e)e.disabled=!on});
  $('mpxStage').classList.toggle('has-photo',on);
}
function loadFile(file){
  if(!file)return;
  if(!/^image\//.test(file.type)){tip('That doesn’t look like a photo. Please choose a JPG, PNG or WebP image.',true);return}
  if(file.size>30*1024*1024){tip('That photo is over 30 MB. Please choose a smaller one.',true);return}
  var url=URL.createObjectURL(file),im=new Image();
  im.onload=function(){
    URL.revokeObjectURL(url);
    if(!im.naturalWidth||!im.naturalHeight){tip('We couldn’t read that photo. Please try another one.',true);return}
    var W=1200,H=Math.max(900,Math.min(1500,Math.round(W*im.naturalHeight/im.naturalWidth)));
    cv.width=W;cv.height=H;
    var bg=document.createElement('canvas');bg.width=W;bg.height=H;var b=bg.getContext('2d');
    var k=Math.max(W/im.naturalWidth,H/im.naturalHeight),w=im.naturalWidth*k,h=im.naturalHeight*k;
    b.imageSmoothingQuality='high';b.drawImage(im,(W-w)/2,(H-h)/2,w,h);
    st.bg=bg;st.has=true;resetPlace();enable(true);render();
    tip('Drag the costume so your pup’s face fills the hood opening. Pinch or use the sliders to resize.');
    $('mpxStage').scrollIntoView({behavior:'smooth',block:'nearest'});
  };
  im.onerror=function(){URL.revokeObjectURL(url);tip('We couldn’t open that photo. Some formats (like HEIC) aren’t supported in every browser. Please try a JPG or PNG.',true)};
  im.src=url;
}
function pickColor(c,fromStore){
  st.color=c;
  document.querySelectorAll('#mpxColors [data-pcolor]').forEach(function(b){var on=b.dataset.pcolor===c;b.classList.toggle('selected',on);b.setAttribute('aria-pressed',String(on))});
  if(!fromStore&&typeof state!=='undefined'&&state.color!==c)selectColor(c);
  syncBuy();render();
}
function syncBuy(){
  if(typeof state==='undefined')return;
  var duo=state.bundle;
  $('mpxBuyTitle').textContent=duo?'Christmas Duo · 2 costumes':(state.color+' · Size '+state.size);
  $('mpxBuyPrice').textContent=duo?'$49.99 for two (save $49.99)':'$29.99 · was $49.99';
}
document.addEventListener('mp:state',function(){
  if(typeof state!=='undefined'&&state.color!==st.color)pickColor(state.color,true);else syncBuy();
});

/* pointer interaction */
var ptrs=new Map(),g0=null;
function pos(e){var r=cv.getBoundingClientRect(),k=cv.width/r.width;return{x:(e.clientX-r.left)*k,y:(e.clientY-r.top)*k}}
cv.addEventListener('pointerdown',function(e){
  if(!st.has){$('mpxFile').click();return}
  try{cv.setPointerCapture(e.pointerId)}catch(err){}ptrs.set(e.pointerId,pos(e));$('mpxStage').classList.add('moving');cv.focus({preventScroll:true});
  g0=null;
});
cv.addEventListener('pointermove',function(e){
  if(!ptrs.has(e.pointerId))return;
  var p=pos(e),prev=ptrs.get(e.pointerId);
  if(ptrs.size===1){st.x+=p.x-prev.x;st.y+=p.y-prev.y;ptrs.set(e.pointerId,p)}
  else if(ptrs.size===2){
    ptrs.set(e.pointerId,p);var a=Array.from(ptrs.values()),dx=a[1].x-a[0].x,dy=a[1].y-a[0].y,d=Math.hypot(dx,dy),ang=Math.atan2(dy,dx);
    if(!g0)g0={d:d||1,ang:ang,s:st.scale,r:st.rot};
    st.scale=Math.max(.3,Math.min(2.2,g0.s*d/g0.d));st.rot=Math.max(-90,Math.min(90,g0.r+(ang-g0.ang)*180/Math.PI));syncUI();
  }
  render();
});
function endPtr(e){ptrs.delete(e.pointerId);g0=null;if(!ptrs.size)$('mpxStage').classList.remove('moving')}
cv.addEventListener('pointerup',endPtr);cv.addEventListener('pointercancel',endPtr);
cv.addEventListener('keydown',function(e){
  if(!st.has)return;var step=e.shiftKey?40:12,used=true;
  switch(e.key){
    case'ArrowLeft':st.x-=step;break;case'ArrowRight':st.x+=step;break;case'ArrowUp':st.y-=step;break;case'ArrowDown':st.y+=step;break;
    case'+':case'=':st.scale=Math.min(2.2,st.scale+.04);break;case'-':case'_':st.scale=Math.max(.3,st.scale-.04);break;
    case'[':st.rot=Math.max(-90,st.rot-3);break;case']':st.rot=Math.min(90,st.rot+3);break;
    case'f':case'F':st.flip=!st.flip;break;default:used=false;
  }
  if(used){e.preventDefault();syncUI();render()}
  else if(e.key==='Enter'||e.key===' '){}
});
cv.addEventListener('keydown',function(e){if(!st.has&&(e.key==='Enter'||e.key===' ')){e.preventDefault();$('mpxFile').click()}});

/* controls */
$('mpxDrop').addEventListener('click',function(){$('mpxFile').click()});
$('mpxChange').addEventListener('click',function(){$('mpxFile').click()});
$('mpxFile').addEventListener('change',function(e){var f=e.target.files&&e.target.files[0];loadFile(f);e.target.value=''});
var stage=$('mpxStage');
['dragenter','dragover'].forEach(function(t){stage.addEventListener(t,function(e){e.preventDefault();stage.classList.add('drag')})});
['dragleave','drop'].forEach(function(t){stage.addEventListener(t,function(e){e.preventDefault();stage.classList.remove('drag')})});
stage.addEventListener('drop',function(e){var f=e.dataTransfer&&e.dataTransfer.files&&e.dataTransfer.files[0];loadFile(f)});
$('mpxColors').addEventListener('click',function(e){var b=e.target.closest('[data-pcolor]');if(b)pickColor(b.dataset.pcolor,false)});
$('mpxScale').addEventListener('input',function(e){st.scale=Number(e.target.value)/100;syncUI();render()});
$('mpxRot').addEventListener('input',function(e){st.rot=Number(e.target.value);syncUI();render()});
$('mpxFlip').addEventListener('click',function(){st.flip=!st.flip;render()});
$('mpxReset').addEventListener('click',function(){resetPlace();render()});
$('mpxName').addEventListener('input',function(e){st.name=e.target.value.trim();render()});
$('mpxSnow').addEventListener('change',function(e){st.snow=e.target.checked;render()});
function fileName(){var n=(st.name||'pup').replace(/[^a-z0-9]+/gi,'-').replace(/^-|-$/g,'').toLowerCase()||'pup';return 'merrypaws-'+n+'.png'}
function blobOf(cb){if(cv.toBlob)cv.toBlob(cb,'image/png');else cb(null)}
$('mpxSave').addEventListener('click',function(){
  blobOf(function(blob){
    var a=document.createElement('a');a.download=fileName();
    if(blob){a.href=URL.createObjectURL(blob)}else{a.href=cv.toDataURL('image/png')}
    document.body.appendChild(a);a.click();a.remove();
    if(blob)setTimeout(function(){URL.revokeObjectURL(a.href)},2000);
    toast('Saved! Merry Christmas 🎄');
  });
});
if(navigator.canShare&&navigator.share){
  $('mpxShare').hidden=false;
  $('mpxShare').addEventListener('click',function(){
    blobOf(function(blob){
      if(!blob)return;var f=new File([blob],fileName(),{type:'image/png'});
      if(navigator.canShare({files:[f]}))navigator.share({files:[f],title:'My pup in MerryPaws'}).catch(function(){});
      else toast('Sharing isn’t supported here. Use Save instead.');
    });
  });
}
$('mpxAdd').addEventListener('click',function(){add()});
$('mpxFit').addEventListener('click',function(){openSize()});

/* put the preview in the right place for the current page */
var homeMount=$('mpxHomeMount'),prodMount=$('mpxProductMount'),section=$('tryon');
window.mpxPlacePreview=function(isProduct){
  var m=isProduct?prodMount:homeMount;
  if(m&&section&&section.parentNode!==m)m.appendChild(section);
};

initFit();loadCostumes();resetPlace();enable(false);render();syncBuy();
window.mpxPlacePreview(document.body.classList.contains('product-mode'));
})();

